// @flow

import gql from 'graphql-tag';

const appDirectoryNavQuery = gql`
  query appDirectoryNavQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      slug
      isBuiltIn
      appAlternatives {
        totalCount
      }
      reviewPage {
        id
      }
    }

    appSupportNotes(appSlug: $slug) {
      id
    }

    blogPostsV2(categorySlug: "app-tutorial", serviceSlug: $slug) {
      totalCount
    }
  }
`;

export default appDirectoryNavQuery;
